import React from 'react';
import { Container } from './chat-message-box-styles';
import Arrow from './arrow';
var ChatMessageBox = function (_a) {
    var direction = _a.direction, children = _a.children;
    return (React.createElement(Container, null,
        React.createElement(Arrow, { direction: direction }),
        children));
};
export default ChatMessageBox;
